import {Injectable} from '@angular/core';
import {FeatureFlag} from '@emma-labs/shared/typescript';
import {from, Observable, of} from 'rxjs';
import {FeatureFlagService} from './feature-flag.service';

@Injectable({
  providedIn: 'root',
})
export class LocalFeatureFlagService implements FeatureFlagService {
  initialize(): Observable<void> {
    return from(Promise.resolve());
  }

  reinitialize(): Observable<void> {
    return from(Promise.resolve());
  }

  isEnabled(featureFlag: FeatureFlag): Observable<boolean> {
    return of(featureFlag.value);
  }
}
